<template>
  <div class="pt-1 position-relative">
    <div
      v-if="foldersLoadingParent"
      class="position-absolute d-flex justify-content-center py-20 w-100"
    >
      <wtr-loader class="d-block" variant="primary" addText></wtr-loader>
    </div>

    <div :class="{ 'fetch-class': foldersLoadingParent }">
      <v-jstree
        v-if="folders && folders.length"
        :data="folders"
        :show-checkbox="false"
        :allow-batch="true"
        @item-click="selectNode"
      >
        <template slot-scope="_">
          <div :title="_.model.name">
            <div v-on:click.prevent="selectNode(_.model)" :class="getActiveClass(_.model)">
              <span><img v-if="!_.model.loading" class="folder-icon-img-size" :src="require('@/assets/icons-new/'+getFolderIcon(_.model)+'.svg')" alt="Icon" /></span>
              <span>&nbsp;{{_.model.name}}</span>
            </div>
          </div>
        </template>
      </v-jstree>

      <div v-else class="text-center py-3">
        No folders available
      </div>
    </div>
  </div>
</template>

<script>
import VJstree from "vue-jstree";

export default {
  name: "presentation-folders",
  data() {
    return {
      foldersLoadingParent: false,
    };
  },
  components: {
    VJstree,
  },
  props: {
    foldersLoading: Boolean,
    rootFolder: Object,
    selectedFolder: Object,
    copiedFolder: Object,
    activeFolder: Object,
    folders: {
      type: Array,
      default: () => [],
    },
    disableActions: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    foldersLoading: {
      immediate: true,
      handler(newVal) {
        this.foldersLoadingParent = newVal;
      },
    },
    folders: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length && !this.activeFolder) {
          this.selectNode(newVal[0]);
        }
      },
    },
  },
  methods: {
    getFolderIcon({ folderType }) {
      switch (folderType) {
        case "PRESENTATIONPUBLIC":
          return "Icons_PublicAccessBox";
        case "PRESENTATION":
          return "Icons_Folder";
        default:
          return "Icons_Folder";
      }
    },
    selectNode(model) {
      this.$emit("selected", model.model || model);
    },
    getActiveClass(node) {
      if (!this.activeFolder || !node) return "";
      const forRoot = node && node.name === this.activeFolder.name;
      return forRoot ? "fw-700" : "";
    },
  },
};
</script>

<style scoped lang="scss">
.folder-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.folder-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
